'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle() {
}
export { $c_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle as $c_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle };
$p = $c_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle;
/** @constructor */
function $h_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle() {
}
export { $h_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle as $h_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle };
$h_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.pages.view_document.-View-Invoice$-Render-Style.js.map
